import { render, staticRenderFns } from "./UtilityListManagerLayout.vue?vue&type=template&id=28bb382c&scoped=true&"
import script from "./UtilityListManagerLayout.vue?vue&type=script&lang=js&"
export * from "./UtilityListManagerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb382c",
  null
  
)

export default component.exports